import { Dispatch } from 'redux';
import {
  imageSettingsChangeImageTypeAction,
} from './actions';

export const imageSettingsChangeImageType = (imageType: string) => (dispatch: Dispatch) => {
  dispatch(imageSettingsChangeImageTypeAction(imageType));
};
